import { Controller } from '@hotwired/stimulus'

import {
  initTomSelect,
  destroyTomSelect,
  refreshTomSelectOptions,
} from '../vendors/tom_select'

export default class extends Controller {

  initialize() {
    this.form = this.element
  }

  connect() {
    this.initSelectsIn(this.form)

    // Dispatched by the nested-form Stimulus controller (see
    // nested_form_controller.js), which replaced cocoon for the
    // missions/rides add-remove UI.
    this.form.addEventListener("nested-form:added", this.handleRowAdded)
    this.form.addEventListener("nested-form:removed", this.handleRowRemoved)
    // Delegated: customer-field selects can be added dynamically, so
    // listen on the form rather than binding at init time per-element.
    this.form.addEventListener("tomselect:change", this.handleTomSelectChange)
  }

  disconnect() {
    this.form.querySelectorAll("select").forEach(destroyTomSelect)
    this.form.removeEventListener("nested-form:added", this.handleRowAdded)
    this.form.removeEventListener("nested-form:removed", this.handleRowRemoved)
    this.form.removeEventListener("tomselect:change", this.handleTomSelectChange)
  }

  initSelectsIn(container) {
    container.querySelectorAll("select").forEach(initTomSelect)
  }

  handleRowAdded = (e) => {
    const row = e.detail.row
    this.initSelectsIn(row)

    if (row.classList.contains("mission-fields")) {
      const missionsCount = this.form.querySelectorAll(".mission-fields").length
      const missionTitleInput = row.querySelector(".mission-title input")
      if (missionTitleInput) missionTitleInput.value = missionsCount
    }
  }

  handleRowRemoved = (e) => {
    const row = e.detail.row
    row.querySelectorAll("select").forEach(destroyTomSelect)
  }

  handleTomSelectChange = (e) => {
    if (e.target.classList.contains("customer-field")) {
      this.customerSelect(e.detail.value, e.target)
    }
  }

  exchangeAddresses(evt) {
    const rideFields = evt.currentTarget.closest(".ride-fields")
    const fromField = rideFields.querySelector(".from-address-field")
    const toField = rideFields.querySelector(".to-address-field")
    const fromValue = fromField.value
    const toValue = toField.value

    fromField.tomselect.setValue(toValue)
    toField.tomselect.setValue(fromValue)
  }

  customerSelect = async (value, selectEl) => {
    const rideFields = selectEl.closest(".ride-fields")
    const fromField = rideFields.querySelector(".from-address-field")
    const toField = rideFields.querySelector(".to-address-field")
    const transportField = rideFields.querySelector(".transport-name-field")
    const customerComments = rideFields.querySelector(".customer-comments")

    const customer = await (await fetch(`/customers/${value}.json`)).json()

    refreshTomSelectOptions(fromField, customer.addresses, customer.home_id)
    refreshTomSelectOptions(toField, customer.addresses, customer.destination_id)

    transportField.tomselect.setValue(customer.default_transport || "")
    customerComments.innerHTML = customer.comments || ""
  }

}
